import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ExpertTeam = () => {
  const experts = [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Senior Gaming Advisor",
      specialty: "Cricket Betting & Live Sports",
      experience: "8+ Years",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      languages: ["Hindi", "English", "Punjabi"],
      rating: 4.9,
      totalChats: "15K+",
      responseTime: "< 1 min",
      expertise: ["Live Cricket Betting", "Match Analysis", "Odds Calculation", "Risk Management"],
      status: "online"
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Casino Games Specialist",
      specialty: "Slots, Roulette & Card Games",
      experience: "6+ Years",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
      languages: ["Hindi", "English", "Marathi"],
      rating: 4.8,
      totalChats: "12K+",
      responseTime: "< 2 min",
      expertise: ["Slot Strategies", "Blackjack", "Roulette Systems", "Bankroll Management"],
      status: "online"
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "VIP Account Manager",
      specialty: "High-Stakes Gaming & VIP Services",
      experience: "10+ Years",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      languages: ["Hindi", "English", "Gujarati"],
      rating: 5.0,
      totalChats: "8K+",
      responseTime: "< 30 sec",
      expertise: ["VIP Programs", "High-Stakes Strategy", "Exclusive Bonuses", "Personal Consultation"],
      status: "online"
    },
    {
      id: 4,
      name: "Sneha Reddy",
      role: "New Player Guide",
      specialty: "Beginner Support & Game Education",
      experience: "4+ Years",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
      languages: ["Hindi", "English", "Telugu"],
      rating: 4.9,
      totalChats: "20K+",
      responseTime: "< 2 min",
      expertise: ["Game Tutorials", "Account Setup", "Payment Methods", "Responsible Gaming"],
      status: "busy"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'online': return 'bg-success';
      case 'busy': return 'bg-warning';
      default: return 'bg-text-muted';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'online': return 'Available Now';
      case 'busy': return 'Busy';
      default: return 'Offline';
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-surface-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-royal rounded-full flex items-center justify-center shadow-royal">
              <Icon name="Users" size={32} color="white" strokeWidth={2} />
            </div>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-gradient-royal mb-6">
            Meet Your Gaming Experts
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Our certified gaming advisors bring years of experience and personalized expertise to help you maximize your gaming potential.
          </p>
        </div>

        {/* Experts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {experts?.map((expert) => (
            <div 
              key={expert?.id}
              className="bg-surface rounded-card shadow-subtle hover:shadow-royal transition-royal hover-lift overflow-hidden"
            >
              {/* Expert Image & Status */}
              <div className="relative">
                <div className="aspect-square overflow-hidden">
                  <Image
                    src={expert?.avatar}
                    alt={expert?.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Status Indicator */}
                <div className="absolute top-4 right-4">
                  <div className={`w-4 h-4 ${getStatusColor(expert?.status)} rounded-full border-2 border-white shadow-subtle ${
                    expert?.status === 'online' ? 'animate-pulse' : ''
                  }`}></div>
                </div>

                {/* Rating Badge */}
                <div className="absolute bottom-4 left-4">
                  <div className="bg-background/90 backdrop-blur-sm rounded-button px-2 py-1 flex items-center space-x-1">
                    <Icon name="Star" size={14} color="var(--color-warning)" />
                    <span className="text-sm font-semibold text-text-primary">{expert?.rating}</span>
                  </div>
                </div>
              </div>

              {/* Expert Info */}
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-xl font-heading font-bold text-text-primary mb-1">
                    {expert?.name}
                  </h3>
                  <p className="text-sm font-medium text-primary mb-2">
                    {expert?.role}
                  </p>
                  <p className="text-sm text-text-secondary">
                    {expert?.specialty}
                  </p>
                </div>

                {/* Status & Response Time */}
                <div className="flex items-center justify-between mb-4 p-3 bg-muted rounded-button">
                  <div className="flex items-center space-x-2">
                    <div className={`w-2 h-2 ${getStatusColor(expert?.status)} rounded-full ${
                      expert?.status === 'online' ? 'animate-pulse' : ''
                    }`}></div>
                    <span className="text-sm font-medium text-text-primary">
                      {getStatusText(expert?.status)}
                    </span>
                  </div>
                  <span className="text-xs text-text-muted">
                    {expert?.responseTime}
                  </span>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="text-center">
                    <p className="text-lg font-bold text-primary">{expert?.totalChats}</p>
                    <p className="text-xs text-text-muted">Conversations</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-accent">{expert?.experience}</p>
                    <p className="text-xs text-text-muted">Experience</p>
                  </div>
                </div>

                {/* Languages */}
                <div className="mb-4">
                  <p className="text-xs text-text-muted mb-2">Languages:</p>
                  <div className="flex flex-wrap gap-1">
                    {expert?.languages?.map((lang, index) => (
                      <span 
                        key={index}
                        className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-button"
                      >
                        {lang}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Expertise Tags */}
                <div className="mb-6">
                  <p className="text-xs text-text-muted mb-2">Expertise:</p>
                  <div className="flex flex-wrap gap-1">
                    {expert?.expertise?.slice(0, 2)?.map((skill, index) => (
                      <span 
                        key={index}
                        className="text-xs bg-accent/10 text-accent px-2 py-1 rounded-button"
                      >
                        {skill}
                      </span>
                    ))}
                    {expert?.expertise?.length > 2 && (
                      <span className="text-xs bg-muted text-text-muted px-2 py-1 rounded-button">
                        +{expert?.expertise?.length - 2} more
                      </span>
                    )}
                  </div>
                </div>

                {/* Contact Button */}
                <button
                  onClick={() => window.open(`https://wa.me/917704070169?text=Hi ${expert?.name}, I would like to get expert advice about ${expert?.specialty?.toLowerCase()}.`, '_blank')}
                  className={`w-full py-3 px-4 rounded-button font-medium transition-royal ${
                    expert?.status === 'online' ?'bg-gradient-royal text-white hover:shadow-glow' :'bg-muted text-text-secondary cursor-not-allowed'
                  }`}
                  disabled={expert?.status !== 'online'}
                >
                  {expert?.status === 'online' ? 'Chat Now' : 'Currently Busy'}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Team Stats */}
        <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5 rounded-card p-8 border border-golden">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Users" size={24} color="white" strokeWidth={2} />
              </div>
              <p className="text-2xl font-bold text-text-primary mb-2">15+</p>
              <p className="text-sm text-text-secondary">Gaming Experts</p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="MessageSquare" size={24} color="white" strokeWidth={2} />
              </div>
              <p className="text-2xl font-bold text-text-primary mb-2">50K+</p>
              <p className="text-sm text-text-secondary">Happy Conversations</p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Clock" size={24} color="white" strokeWidth={2} />
              </div>
              <p className="text-2xl font-bold text-text-primary mb-2">&lt; 2 Min</p>
              <p className="text-sm text-text-secondary">Average Response</p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Star" size={24} color="white" strokeWidth={2} />
              </div>
              <p className="text-2xl font-bold text-text-primary mb-2">4.9/5</p>
              <p className="text-sm text-text-secondary">Customer Rating</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertTeam;